/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useIntl } from 'react-intl'
import { KTIcon } from '../../../../helpers'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { featureFlags } from '../../../../../config/countryConfig'

const SidebarMenuMain = () => {
  const intl = useIntl()

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='element-11'
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
        fontIcon='bi-app-indicator'
      />
      {featureFlags.urlMappedTemplates && (
        <SidebarMenuItem
          to='/managetemplate'
          icon='setting-3'
          title={intl.formatMessage({ id: 'PAGE.MANAGE_TEMPLATE', defaultMessage: 'URL Mapped Templates' })}
          fontIcon='bi-app-indicator'
        />
      )}
      <SidebarMenuItem
        to='/smsreport'
        icon='notepad'
        title={intl.formatMessage({ id: 'NAV.MESSAGE_DATA', defaultMessage: 'Message Data' })}
      />
      <SidebarMenuItem
        to='/iplist'
        icon='text-number'
        title={intl.formatMessage({ id: 'PAGE.IP_LIST', defaultMessage: 'PE-TM Details' })}
        fontIcon='bi-app-indicator'
      />
      <SidebarMenuItemWithSub
        to='/blacklist'
        icon='information-5'
        title={intl.formatMessage({ id: 'PAGE.GLOBAL_BLACKLIST', defaultMessage: 'Global Blacklist' })}
      >
        <SidebarMenuItem to='/blacklisturl' title={intl.formatMessage({ id: 'NAV.URL_BLACKLIST', defaultMessage: 'URL Blacklist' })} hasBullet={true} />
        <SidebarMenuItem to='/blacklistip' title={intl.formatMessage({ id: 'NAV.IP_BLACKLIST', defaultMessage: 'IP Blacklist' })} hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItem
        to='/operatordata'
        icon='book'
        title={intl.formatMessage({ id: 'PAGE.ACCOUNT_STATISTICS', defaultMessage: 'Account Statistics' })}
        fontIcon='bi-app-indicator'
      />
      <SidebarMenuItem
        to='/paymentreport'
        icon='book'
        title={intl.formatMessage({ id: 'NAV.PAYMENT_REPORT', defaultMessage: 'Payment Report' })}
        fontIcon='bi-app-indicator'
      />
      <SidebarMenuItemWithSub
        to='/account'
        icon='information-5'
        title={intl.formatMessage({ id: 'NAV.ACCOUNT_CONTROL', defaultMessage: 'Account Control' })}
      >
        <SidebarMenuItem to='/rolesmanagement' title={intl.formatMessage({ id: 'PAGE.ROLES_MANAGEMENT', defaultMessage: 'Roles Management' })} hasBullet={true} />
        <SidebarMenuItem to='/usermanagement' title={intl.formatMessage({ id: 'PAGE.USER_MANAGEMENT', defaultMessage: 'User Management' })} hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItem
        to='/support'
        icon='message-question'
        title={intl.formatMessage({ id: 'NAV.TICKET_SUPPORT', defaultMessage: 'Ticket Support' })}
        fontIcon='bi-app-indicator'
      />
      {/* <SidebarMenuItem to='/builder' icon='switch' title='Layout Builder' fontIcon='bi-layers' />
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Crafted</span>
        </div>
      </div>
      <SidebarMenuItemWithSub
        to='/crafted/pages'
        title='Pages'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        <SidebarMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>
          <SidebarMenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
          <SidebarMenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
          <SidebarMenuItem
            to='/crafted/pages/profile/campaigns'
            title='Campaigns'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/documents'
            title='Documents'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/connections'
            title='Connections'
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>

        <SidebarMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}>
          <SidebarMenuItem
            to='/crafted/pages/wizards/horizontal'
            title='Horizontal'
            hasBullet={true}
          />
          <SidebarMenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
        </SidebarMenuItemWithSub>
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/crafted/accounts'
        title='Accounts'
        icon='profile-circle'
        fontIcon='bi-person'
      >
        <SidebarMenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
        <SidebarMenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub to='/error' title='Errors' fontIcon='bi-sticky' icon='cross-circle'>
        <SidebarMenuItem to='/error/404' title='Error 404' hasBullet={true} />
        <SidebarMenuItem to='/error/500' title='Error 500' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/crafted/widgets'
        title='Widgets'
        icon='element-7'
        fontIcon='bi-layers'
      >
        <SidebarMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
        </div>
      </div>
      <SidebarMenuItemWithSub
        to='/apps/chat'
        title='Chat'
        fontIcon='bi-chat-left'
        icon='message-text-2'
      >
        <SidebarMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
        <SidebarMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
        <SidebarMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItem
        to='/apps/user-management/users'
        icon='abstract-28'
        title='User management'
        fontIcon='bi-layers'
      />
      <div className='menu-item'>
        <a
          target='_blank'
          className='menu-link'
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
        >
          <span className='menu-icon'>
            <KTIcon iconName='code' className='fs-2' />
          </span>
          <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
        </a>
      </div> */}
    </>
  )
}

export { SidebarMenuMain }
